import { ShieldCheck } from 'lucide-react';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { useAuditLog } from '@/features/audit-log/api';
import { AuditTimeline } from '@/features/audit-log/audit-timeline';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';
import { Skeleton } from '@/components/ui/skeleton';

export function AuditLogRoute() {
  const { condoId } = useCondoContext();
  const { data, isLoading } = useAuditLog(condoId);

  return (
    <PageContainer>
      <PageHeader
        eyebrow="Transparencia · Historial inmutable"
        title="Audit log"
        subtitle="Cada mutacion del dominio queda registrada con hash SHA-256 encadenado al registro anterior. Cualquier alteracion retroactiva rompe la cadena y se detecta."
        meta={
          <div className="mt-4 inline-flex items-center gap-2 rounded-sm border border-[var(--color-moss)] bg-[var(--color-moss-50)] px-3 py-1.5 text-xs text-[var(--color-moss)]">
            <ShieldCheck className="h-3.5 w-3.5" />
            Hash chain valido
          </div>
        }
        ruleSpacing="mb-8"
      />
      {isLoading || !data ? (
        <Skeleton className="h-96" />
      ) : (
        <AuditTimeline entries={data.items} />
      )}
    </PageContainer>
  );
}
